export default {
    userRoleCategoryType: [
        'Admin', 'Configuration', 'Financials', 'Maintenance_Event', 'Occupancy', 'Reports', 'Retail_Sale',
        'Syrapay_Merchant_Portal', 'Tenant', 'Unit',
    ],
};
